import { __module as withSelector } from "../../../_virtual/with-selector2.mjs";
import { __require as requireWithSelector_production_min } from "../cjs/use-sync-external-store-shim/with-selector.production.min.mjs";
import { __require as requireWithSelector_development } from "../cjs/use-sync-external-store-shim/with-selector.development.mjs";
var hasRequiredWithSelector;
function requireWithSelector() {
  if (hasRequiredWithSelector) return withSelector.exports;
  hasRequiredWithSelector = 1;
  if (process.env.NODE_ENV === "production") {
    withSelector.exports = requireWithSelector_production_min();
  } else {
    withSelector.exports = requireWithSelector_development();
  }
  return withSelector.exports;
}
export {
  requireWithSelector as __require
};
//# sourceMappingURL=with-selector.mjs.map
